import { useState } from "react";
import { Link } from "react-router-dom";
import { Menu, X, ArrowDownToLine } from "lucide-react";
import { scrollToId } from "@/lib/api";

const LINKS = [
  { label: "About", id: "about" },
  { label: "Upcoming Project", id: "project" },
  { label: "Carriers", id: "carriers" },
  { label: "Onboarding", id: "onboarding" },
  { label: "Contact", id: "contact" },
];

export const Logo = ({ className = "h-12" }) => (
  <div className="rounded-lg bg-white px-3 py-2 shadow-lg shadow-black/30">
    <img src="/logo.png" alt="PORTBRIDGE Global" className={`${className} w-auto`} />
  </div>
);

export default function Nav({ settings }) {
  const [open, setOpen] = useState(false);

  const go = (id) => {
    setOpen(false);
    scrollToId(id);
  };

  return (
    <header className="fixed inset-x-0 top-0 z-50 glass border-b border-[#0066FF]/20">
      <nav className="mx-auto flex max-w-7xl items-center justify-between px-5 py-3 lg:px-8">
        <button
          data-testid="navigation-brand-logo"
          onClick={() => window.__lenis ? window.__lenis.scrollTo(0) : window.scrollTo(0, 0)}
          className="flex items-center gap-3"
        >
          <Logo />
        </button>

        <div className="hidden items-center gap-8 lg:flex">
          {LINKS.map((l) => (
            <button
              key={l.id}
              data-testid={`navigation-link-${l.id}`}
              onClick={() => go(l.id)}
              className="text-sm font-medium text-slate-300 transition-colors hover:text-white"
            >
              {l.label}
            </button>
          ))}
          <button
            data-testid="navigation-btn-portal"
            onClick={() => go("onboarding")}
            className="group flex items-center gap-2 rounded-full bg-[#0066FF] px-5 py-2.5 text-sm font-semibold text-white transition-all hover:bg-[#0052cc] hover:shadow-[0_0_30px_rgba(0,102,255,0.5)]"
          >
            <ArrowDownToLine className="h-4 w-4 transition-transform group-hover:translate-y-0.5" />
            Carrier Portal
          </button>
        </div>

        <button
          data-testid="navigation-mobile-toggle"
          className="rounded-lg p-2 text-slate-200 lg:hidden"
          onClick={() => setOpen(!open)}
        >
          {open ? <X className="h-6 w-6" /> : <Menu className="h-6 w-6" />}
        </button>
      </nav>

      {open && (
        <div className="border-t border-[#0066FF]/20 bg-[#0B172A]/95 px-5 pb-6 pt-2 lg:hidden">
          {LINKS.map((l) => (
            <button
              key={l.id}
              onClick={() => go(l.id)}
              className="block w-full py-3 text-left text-base font-medium text-slate-200"
            >
              {l.label}
            </button>
          ))}
          <button
            onClick={() => go("onboarding")}
            className="mt-3 flex w-full items-center justify-center gap-2 rounded-full bg-[#0066FF] px-5 py-3 text-sm font-semibold text-white"
          >
            <ArrowDownToLine className="h-4 w-4" /> Carrier Portal
          </button>
        </div>
      )}
    </header>
  );
}
